
import { UserInfo } from '@/types/user-info';
import { Component, Vue } from 'vue-property-decorator';
import TopNavBar from '@/components/app/TopNavBar.vue';
import { DeviceInfo, DeviceType } from '@/types/device-info';
import { State } from 'vuex-class';
import { mutations } from '@/store/types';
import api from '@/modules/api';
import { getErrorMessage } from '@/utils/common';

@Component({
    components: { TopNavBar },
})
export default class UserSettings extends Vue {
    DeviceTypeenum = DeviceType;
    tab = 'account';
    tabs = [
        {
            value: 'account',
            title: 'Account settings',
            to: 'account',
        },
    ];

    @State('user')
    user!: UserInfo;

    @State('devices')
    devices!: DeviceInfo[];

    mounted() {
        this.getGPSDevices();
    }

    async getGPSDevices() {
        this.$store.commit(mutations.LOADING, { loading: true });
        try {
            const gpsDevices = await api.loadDevices(
                this.user._id as string,
                { page: 0, perPage: 999 },
                this.DeviceTypeenum.AirboltGps,
                '',
            );
            if (gpsDevices.length > 0) {
                this.tabs = [
                    {
                        value: 'account',
                        title: 'Account settings',
                        to: 'account',
                    },
                    {
                        value: 'payments',
                        title: 'Payments',
                        to: 'payments',
                    },
                ];
            }
            this.$store.commit(mutations.LOADING, { loading: false });
        } catch (error) {
            this.$store.commit(mutations.LOADING, { loading: false });
            Vue.toasted.error(getErrorMessage(error, `Something went wrong while fetching devices`));
        }
    }
}
